import {$$} from '@vue-macros/reactivity-transform/macros'

import {IFilter} from '@toolify/server/src/services/FilterService/types/IFilter'
import {FilterItemType} from '@toolify/server/src/services/FilterService/enum/FilterItemType'
import {FilterPropertyOperator} from '@toolify/server/src/services/FilterService/enum/FilterPropertyOperator'
import {FilterPropertyPayloadType} from '@toolify/server/src/services/FilterService/enum/FilterPropertyPayloadType'
import {
  IDatabaseGroupItemResponseInstance,
} from '@toolify/server/src/controllers/DatabaseItemController/validators/GetGroups/types/IDatabaseGroupItemResponseInstance'
import {IRelationPropertyTypeInterfaces} from '@toolify/server/src/services/DatabasePropertyService/strategies/ColumnTypeStrategies/RelationPropertyTypeStrategy/types/IRelationPropertyTypeInterfaces'

export function useRelationPropertyTypeStrategy() {

  const getGroupFilter = (group: string, groupItem: IDatabaseGroupItemResponseInstance, showAllDatabaseGroups: boolean): IFilter => {
    const relationValue = groupItem?.value as IRelationPropertyTypeInterfaces['fullValue']
    const firstItemId = relationValue?.firstItems?.[0]?.id ?? null
    if(!firstItemId) {
      return {
        type: FilterItemType.Property,
        id: group,
        operator: {
          type: FilterPropertyOperator.ArrayEmpty,
          options: {},
        },
        subProperty: 'firstItems',
        payload: {
          type: FilterPropertyPayloadType.Static,
          value: null,
        },
        isDisabled: false,
      }
    }
    return {
      type: FilterItemType.Property,
      id: group,
      operator: {
        type: FilterPropertyOperator.ArrayContains,
        options: {
          subProperty: 'id',
          isCaseSensitive: true,
        },
      },
      subProperty: 'firstItems',
      payload: {
        type: FilterPropertyPayloadType.Static,
        value: firstItemId,
      },
      isDisabled: false,
    }
  }

  return $$({
    getGroupFilter,
  })
}

